import React from 'react';
import ModalManager from './ModalManager';
import Modal from './Modal';

class ModalContainer extends React.Component {

  state = {
    data: {}
  };

  componentWillMount = () => {
    ModalManager.addToggleListener(this.handleToggle);
  };

  componentWillUnmount = () => {
    ModalManager.removeToggleListener(this.handleToggle);
  };

  handleToggle = (data) => {
    this.setState({
      data
    });
  };

  render() {
    const {data} = this.state;
    return (
      <Modal
        data={data}
      />
    );
  }
}

export default ModalContainer;
